import { AdErrorStruct, PlayerAdEvent } from "@mp-commons/modules/ads/PlayerAdEvent.js";
import { MediaEvent, MediaProgressEvent, isMediaCompleteEvent, isMediaImpressionEvent, isMediaStartedEvent } from "@mp-commons/modules/events/PlayerEvent.js";
import { YMSourceStatsCollector } from "@mp-commons/modules/stats/collectors/YMSourceStatsCollector.js";
import { YMStatsCollector, YMStatsMapperConfig } from "@mp-commons/modules/stats/collectors/YMStatsCollector.js";
import { DEFAULT_AD_EVENTS_TO_TRIGGER, PreFilteredEventMapper } from "@mp-commons/modules/stats/mappers/PreFilteredEventMapper.js";
import { VideoInfoRawData } from "@mp-commons/model/video/VideoInfo.js";

const milestoneEventLabelMap = {
    "25": "video_first_quartile",
    "50": "video_half",
    "75": "video_third_quartile",
    "90": "video_ninety_percent"

};

export class MegarideYMStatsMapper extends PreFilteredEventMapper<VideoInfoRawData>{
    



    private sourceStats: YMSourceStatsCollector;
    private stats: YMStatsCollector;

    constructor(private window: Window,
                private config: YMStatsMapperConfig) {
        super({
            media: config.media,
            aderrors: config.aderrors?true:false,
            adevents: config.adevents?DEFAULT_AD_EVENTS_TO_TRIGGER:[],
            progressMilestones: config.media_progress?[25,50,75,90]:[]
        });
        const bname = "https://" + this.config.ymHostname + "/";
        this.sourceStats = new YMSourceStatsCollector(this.window,`${bname}svs.gif`);
        this.stats = new YMStatsCollector(this.window,`${bname}s.gif`);
    }

    

    protected onAdError(errorStruct: AdErrorStruct, adjustedLabel?: string,adjustedEventLabel?: string): void {
        //this.errroLogger.collectError(errorStruct);
        if(errorStruct && errorStruct.vinfo && errorStruct.vinfo.id) {
            this.sourceStats.collectEvent(
                errorStruct.vinfo.id, 
                `${adjustedLabel}_aderror`,
                this.config.embedType,
                this.config.product,
                this.config.playerName
            );
        }
    }

    protected onAdEvent(evt: PlayerAdEvent, adjustedLabel?: string,adjustedEventLabel?: string): void {
        const composite_label= `${adjustedLabel}_${adjustedEventLabel}`
        this.sourceStats.collectEvent(evt.mediaId,
            composite_label,
            this.config.embedType,
            this.config.product,
            this.config.playerName
        );
        //this.stats.collectEvent(evt.mediaId,composite_label,this.config.playerName);
    }

    protected onMediaProgress(progEvent: MediaProgressEvent, corrected_percentage: number): void {
        const pct = corrected_percentage.toString() 
        const label = pct in milestoneEventLabelMap?milestoneEventLabelMap[pct]:null;
        if(label) {
            this.sourceStats.collectEvent(
                progEvent.mediaId,
                label, 
                this.config.embedType,
                this.config.product,
                this.config.playerName
            );
        }
        
    }
    protected onMediaEvent(evt: MediaEvent<VideoInfoRawData>): void {
        if(isMediaStartedEvent(evt)) {
            this.stats.collectEvent(evt.mediaId,"clip_started",this.config.playerName);
            this.sourceStats.collectEvent(evt.mediaId,"video_started",
                this.config.embedType,
                this.config.product,
                this.config.playerName
            );
        }
        else if (isMediaImpressionEvent(evt)) {
            this.stats.collectEvent(evt.mediaId,"video_impression",this.config.playerName);
            this.sourceStats.collectEvent(evt.mediaId,"video_impression",
                this.config.embedType,
                this.config.product,
                this.config.playerName
            );
        }
        else if (isMediaCompleteEvent(evt)) {
            this.sourceStats.collectEvent(evt.mediaId,"video_completed",
                this.config.embedType,
                this.config.product,
                this.config.playerName
            );
        }
    }

   
    
    
}